import React, { FormEvent, useState } from 'react';
import { Box, TextField, Button, Container, AlertColor } from '@mui/material';
import AlertSnackbar from '../AlertaUsuario';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import HeaderWithoutMenu from '../CabecalhoSemMenu';
import { apiServer } from '../../api';
import { sha256 } from '../../common/utils/funcoes';
import { useLocation, useNavigate } from 'react-router-dom';

const ResetPassword = () => {
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [newPassword, setNewPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [tipoAlerta, setTipoAlerta] = React.useState<AlertColor>('error');  
  const navigate = useNavigate();  

  const location = useLocation();  
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');   

  const handleCloseAlert = () => setAlertOpen(false);

  const showAlert = (tipoAlerta: AlertColor, message: string) => {
    setAlertOpen(false);
    setTipoAlerta(tipoAlerta);
    setAlertMessage(message);
    setAlertOpen(true);
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault(); // Evita o comportamento padrão de recarregar a página
    
    if (newPassword !== confirmPassword) {
      showAlert('error', 'A nova senha e a confirmação não coincidem.');
    } else if (solicitarSenhaSegura()) {
      apiServer<string>().post("/usuario/redefinir-senha",
        '',
        {
          novaSenha: await sha256(newPassword),
          token
        })
        .then(() => {
          handleCloseAlert();
          showAlert('success', 'Senha alterada com sucesso');
          navigate("/login", { replace: true });
        }).catch((response) => {
          showAlert('error', response);
        });
    }
  };

  const solicitarSenhaSegura = () => {
    const requisitos = [
      { regex: /.{8,}/, mensagem: "A senha deve ter pelo menos 8 caracteres." },
      { regex: /[A-Z]/, mensagem: "A senha deve conter pelo menos uma letra maiúscula." },
      { regex: /[a-z]/, mensagem: "A senha deve conter pelo menos uma letra minúscula." },
      { regex: /[0-9]/, mensagem: "A senha deve conter pelo menos um número." },
      { regex: /[\W_]/, mensagem: "A senha deve conter pelo menos um caractere especial." },
    ];

    let senhaSegura = false;

    while (!senhaSegura) {
      const erros = requisitos
        .filter(req => !req.regex.test(newPassword))
        .map(req => req.mensagem);

      if (erros.length === 0) {
        senhaSegura = true;
        return true;
      } else {
        showAlert("error", "Senha inválida:\n" + erros.join("\n"));
        return false;
      }
    }
  }

  return (
    <>
      <HeaderWithoutMenu title="Redefinição de senha" />
      <Container maxWidth="sm">

        <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
          <Box component="form" onSubmit={handleSubmit} mt={2}>

            <TextField
              label="Nova Senha"
              type="password"
              margin="normal"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              fullWidth
            />

            <TextField
              label="Confirmar Nova Senha"
              type="password"
              margin="normal"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              fullWidth
            />

            <Box mt={2} display="flex" justifyContent="center">
              <HCaptcha
                sitekey="ba3c2726-c016-4502-b8d4-23d04ba0418a"
                onVerify={(token) => setCaptchaToken(token)}
                onExpire={() => setCaptchaToken(null)}
              />
            </Box>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              disabled={!captchaToken} // Desabilita o botão até o hCaptcha ser validado
            >
              Alterar Senha
            </Button>

            <AlertSnackbar
              open={alertOpen}
              onClose={handleCloseAlert}
              message={alertMessage}
              severity={tipoAlerta} // Define como erro, mas você pode personalizar
            />
          </Box>
        </Box>
      </Container >
    </>
  );
};

export default ResetPassword;